import { Theme, Users } from "@just-in-types";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import AdminControls from "../components/AdminControls";
import Button from "../components/Button";
import Column from "../components/Column";
import Container from "../components/Container";
import Input from "../components/Input";
import Keypad from "../components/Keypad";
import LoaderButton from "../components/LoaderButton";
import Logo from "../components/Logo";
import { prettyMobile } from "../components/methods";
import Row from "../components/Row";
import Title from "../components/Title";
import ErrorBoundary from "../hoc/withErrorBoundary";
import { RouteComponentProps } from "../Site";
import {
  getCheckIns,
  GetCheckIns,
  getLoyaltyCycleText,
  GetLoyaltyCycleText,
  getUser,
  getUserRewardText,
  GetUserRewardText,
  navigateToNext,
  NavigateToNext,
  refreshCoupons,
  RefreshCoupons,
  setLanguage,
  SetLanguage,
  setUserOptedOut,
  setUserValue,
  SetUserValue,
  watchCoupons,
  WatchCoupons,
} from "../store/actions";
import { IState } from "../store/reducers";

interface IMobileDispatchProps {
  onGetCheckIns: GetCheckIns;
  onGetLoyaltyCycleText: GetLoyaltyCycleText;
  onGetUserRewardText: GetUserRewardText;
  onNavigateToNext: NavigateToNext;
  onRefreshCoupons: RefreshCoupons;
  onSetLanguage: SetLanguage;
  onSetUserValue: SetUserValue;
  onWatchCoupons: WatchCoupons;
}
interface IMobileOwnProps extends RouteComponentProps {
  businessId: string;
  siteId: string;
  sitePath: string;
}
interface IMobileStateProps {
  allowOptOut: boolean;
  guid: string;
  optInField: boolean;
  theme: Theme.Props;
  user: Users.User;
}
type MobileProps = IMobileDispatchProps & IMobileOwnProps & IMobileStateProps;

// TODO: remove letters and put mobile back to normal;

interface IMobileState {
  language: Users.Language;
  mobile: string;
  mobileIsValid: boolean;
  nav1: any;
  nav2: any;
  sending: boolean;
  showAdminControls: boolean;
}

interface SelectedBusiness {
  centralFloridaPickAndPay: boolean;
  continueBtnDisable: boolean;
  tearApart: boolean;
  tearApartAll: boolean;
  tearApartCheckinOgden: boolean;
  tearApartCheckinSlc: boolean;
  tearApartJoinOgden: boolean;
  tearApartJoinSlc: boolean;
  tearApartVehicleOgden: boolean;
  tearApartVehicleSlc: boolean;

}

type MobileState = IMobileState & SelectedBusiness;

const MobileContainer = styled(Container)`
  position: relative;
  grid-template-rows: 25vh 55vh 8vh 12vh;
  transition: opacity 500ms ease-in-out;
`;
const MobileNumber = styled(Input)`
  font-family: monospace;
  font-weight: bold;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4rem;
  width: 14rem;
  margin: 0;
  font-size: 1.5rem;
  border: 2px solid black;
  border-right-width: 1px;
  border-radius: 12px 0 0 12px;
  padding-left: 0.5rem;
`;
const BackArrow = () => (
  <svg width="2rem" height="2rem" fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z" />
  </svg>
);

const BackButton = styled(Button)`
  width: 4rem;
  height: 4rem;
  padding: 0.9rem;
`;
const SitePath = styled(Title)`
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  font-size: 1rem;
`;
const DisclaimerText = styled("div")`
  color: ${(props: { color: string }) => props.color};
  text-shadow: 1px 1px 1px black;
  font-size: 10px;
  max-width: 400px;
  @media screen and (max-width: 1440px) {
    width: 85%;
  }
`;

class Mobile extends React.Component<MobileProps, MobileState> {
  public state: MobileState = {
    centralFloridaPickAndPay:false,
    continueBtnDisable:false,
    language: "eng",
    mobile: "",
    mobileIsValid: false,
    nav1: null,
    nav2: null,
    sending: false,
    showAdminControls: false,
    tearApart:false,
    tearApartAll:false,
    tearApartCheckinOgden:false,
    tearApartCheckinSlc:false,
    tearApartJoinOgden:false,
    tearApartJoinSlc:false,
    tearApartVehicleOgden:false,
    tearApartVehicleSlc:false,
  };

  public slider1: any;
  public slider2: any;

  public keypadValidator = (mobile: string, value: string) => {
    let newMobile: string;

    if (mobile.length < 10 && value.match(/[0-9]/)) {
      newMobile = mobile + value;

      if (newMobile.length === 10) {
        this.setState({ mobileIsValid: true });
      }

      return newMobile;
    }

    if (value === "clear") {
      this.setState({ mobileIsValid: false });

      return "";
    }

    if (value === "backspace") {
      newMobile = mobile.slice(0, -1);

      this.setState({ mobileIsValid: false });

      return newMobile;
    }

    return mobile;
  };

  public handleKeypadButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { value } = event.currentTarget;

    const mobile = this.keypadValidator(this.state.mobile, value);

    this.setState({ mobile, showAdminControls: mobile === "0000" });
  };

  public handleInput = ({ currentTarget: { value } }: React.FormEvent<HTMLInputElement>) =>
    this.setState({ mobile: value });

  public handleEnter = async (event: React.MouseEvent<HTMLButtonElement>) => {
    const { name } = event.currentTarget;
    const {
      businessId,
      guid,
      onGetCheckIns,
      onNavigateToNext,
      onSetLanguage,
      onSetUserValue,
      onRefreshCoupons,
      onWatchCoupons,
      siteId,
    } = this.props;
    const { mobile } = this.state;
    // 6028181729 is a placeholder that allows IVision to pick up the check-in

    if (name === "opt-out") {
      console.log("lan", event.currentTarget.dataset.lan);
      const lan = event.currentTarget.dataset.lan;
      if (lan === "eng") {
        onSetLanguage("eng");
      }
      if (lan === "esp") {
        onSetLanguage("esp");
      }

      setUserOptedOut(lan);

      onNavigateToNext();
    } else {
      this.setState({ sending: true, continueBtnDisable:true });

      const timeOut = new Promise((resolve, reject) => {
        const id = setTimeout(() => {
          clearTimeout(id);
          reject("timed out");
        }, 3000);
      });

      let user;

      // Promise.race takes two promises and returns the first resolved one
      // if getUser() takes more than 3 seconds, we skip it
      await Promise.race([getUser(mobile, businessId), timeOut])
        .then((res) => {
          user = res;
        })
        .catch((err) => {
          console.log("Timed out");
          console.log(err);
          user = {};
        });

      if (user.userId) {
        onRefreshCoupons({
          businessId,
          guid,
          mobile: user.mobile,
          userId: user.userId,
        });

        onWatchCoupons(user.userId), onGetCheckIns({ businessId, userId: user.userId });
      }

      let language;
      if (name === "opt-in-english") {
        language = "eng";
        onSetUserValue({ name: "language", value: "eng" });
        onSetLanguage("eng");
      }

      if (name === "opt-in-spanish") {
        language = "esp";
        onSetUserValue({ name: "language", value: "esp" });
        onSetLanguage("esp");
      }
      console.log(businessId, siteId, language, mobile);
      this.props.onGetLoyaltyCycleText(businessId, siteId, language, mobile);
      this.props.onGetUserRewardText(businessId, guid, siteId, language, mobile, user.userId);

      onNavigateToNext();
    }
  };

  public toggleAdminControls = () =>
    this.setState(({ showAdminControls }) => ({
      mobile: "",
      showAdminControls: !showAdminControls,
    }));

  public componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2,
    });


    const { siteId, businessId } = this.props;
    // console.log("ddddddddddddddddddddddd");
    // console.log(businessId);// zDH9H7YbQ0roTbjW23gM
    // console.log(siteId);// R7JASbt9Okbw8qlPfrS4
    // tearApartCheckinOgden
    // tearApartCheckinSlc
    // tearApartJoinOgden
    // tearApartJoinSlc
    // tearApartVehicleOgden
    // tearApartVehicleSlc

    const centralFloridaPickAndPay = (siteId && siteId === 'R7JASbt9Okbw8qlPfrS4' && businessId && businessId === 'zDH9H7YbQ0roTbjW23gM') ? true : false;

    const tearApartJoinSlc = (siteId && siteId === 'FDYHKAMSiYNCuXumk5Iv' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartJoinOgden = (siteId && siteId === 'TMrSaHl6j451pEWxY7nu' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartCheckinSlc = (siteId && siteId === 'kv9ciglhFsJBh9YyV2sd' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartCheckinOgden = (siteId && siteId === '6vVH4qpzsVxjmROhMDmh' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartVehicleSlc = (siteId && siteId === '17VBJyeH2crmqQC2OSxx' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartVehicleOgden = (siteId && siteId === '1YYyeZ1YXjGyc6Z6vwRt' && businessId && businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApart = ((siteId && siteId === 'bsZLKWJMaoIwztWi0gMg' && businessId && businessId === 'WpJtEW5saD7d4bRutXXb') || (siteId && siteId === 'JGOUaPdjCw7AxY1auyYy' && businessId && businessId === 'SmhXMTflviq60mlf221Z')) ? true : false;
    const tearApartAll = tearApart 
                        || tearApartCheckinOgden
                        || tearApartCheckinSlc
                        || tearApartJoinOgden
                        || tearApartJoinSlc
                        || tearApartVehicleOgden
                        || tearApartVehicleSlc;
    this.setState({ centralFloridaPickAndPay, tearApart, tearApartAll, tearApartJoinSlc, tearApartJoinOgden, tearApartCheckinSlc, tearApartCheckinOgden, tearApartVehicleSlc, tearApartVehicleOgden });
  }

  public render() {
    const {
      allowOptOut,
      sitePath,
      optInField,
      theme: { colors, logo },
      site: {
        kioskUiAdvDelaySec,
        kioskUiAllInOneCheckIn,
        kioskUiBackgroundColor,
        kioskUiTextColor,
        kioskUiTitleTextColor,
        kioskUiButtonPrimaryColor,
        kioskUiButtonDisabledColor,
        kioskUiButtonErrorColor,
        kioskUiButtonSuccessColor,
        kioskUiContinueBtnTextColor,
        kioskUiTermTextColor,
        kioskUiTermTextSize,
        kioskUiHideAdvIn,
        kioskUiHideAdvOut,
        kioskUiHideCity,
        kioskUiHideContBtn,
        kioskUiInAdvFile1,
        kioskUiInAdvFile2,
        kioskUiInAdvFile3,
        kioskUiInAdvFile4,
        kioskUiInAdvFile5,
        kioskUiInAdvFile6,
        kioskUiInAdvFile7,
        kioskUiInAdvFile8,
        kioskUiInAdvFile9,
        kioskUiInAdvFile10,
        kioskUiOutAdvFile1,
        kioskUiOutAdvFile2,
        kioskUiOutAdvFile3,
        kioskUiOutAdvFile4,
        kioskUiOutAdvFile5,
        kioskUiOutAdvFile6,
        kioskUiOutAdvFile7,
        kioskUiOutAdvFile8,
        kioskUiOutAdvFile9,
        kioskUiOutAdvFile10,
        kioskUiLogoBorderColor,
        kioskUiLogoBorderEnable,
        kioskUiLogoWidth,
        kioskUiLogoHeight,
        kioskUiTabletView,
        kioskUiVehicleConfig,
      },
      site,
    } = this.props;


    const centralFloridaPickAndPayLogo = "https://firebasestorage.googleapis.com/v0/b/just-in-north.appspot.com/o/kiosk-inside-advertising%2FPolk%20County%20Pick%20%26%20Pay.png?alt=media&token=638c681d-e1ec-42f8-bb7b-9f3dfa93554a";

    const ogden = (this.props.siteId && this.props.siteId === 'JGOUaPdjCw7AxY1auyYy' && this.props.businessId && this.props.businessId === 'SmhXMTflviq60mlf221Z')?true:false;

    const { centralFloridaPickAndPay,
            continueBtnDisable, 
            mobile, 
            mobileIsValid, 
            showAdminControls, 
            sending, 
            tearApart, 
            tearApartAll,
            tearApartCheckinOgden, 
            tearApartCheckinSlc,
            tearApartJoinOgden,
            tearApartJoinSlc,
            tearApartVehicleOgden,
            tearApartVehicleSlc
          } = this.state;
    const sliderSetting = {
      arrows: false,
      autoplay: true,
      autoplaySpeed: kioskUiAdvDelaySec ? Number(kioskUiAdvDelaySec) : 7000,
      dots: false,
    };
    const kioskUiAdvWidth = site.kioskUiAdvWidth ? site.kioskUiAdvWidth : "300px";
    const kioskUiAdvHeight = site.kioskUiAdvHeight ? site.kioskUiAdvHeight : "200px";
    const kioskUiAdvTop = site.kioskUiAdvTop ? site.kioskUiAdvTop : "-200px";
    const kioskUiAdvBottom = site.kioskUiAdvBottom ? site.kioskUiAdvBottom : "20px";
    return (
      <ErrorBoundary>
        <MobileContainer style={{ background: kioskUiBackgroundColor }}>
          <Column align="center" justify="space-around">
            {tearApart || tearApartAll || kioskUiTabletView || kioskUiVehicleConfig || kioskUiAllInOneCheckIn?(
              <div style={{ display : "flex" }}>
                <div style={{color:kioskUiTitleTextColor ? kioskUiTitleTextColor : colors.secondary,fontSize:"40px",display : "flex" ,maxHeight:"12vh", alignItems: "center",justifyContent: "center", height:kioskUiLogoHeight, paddingTop:tearApartVehicleOgden || tearApartVehicleSlc || kioskUiVehicleConfig?"2%":"3%"}}>
                <b>Welcome to the</b> 
                </div>
                <div>
                  <Logo
                    border={kioskUiLogoBorderEnable}
                    borderColor={kioskUiLogoBorderColor ? kioskUiLogoBorderColor : colors.secondary}
                    logo={logo}
                    maxHeight="12vh"
                    kioskUiLogoWidth={kioskUiLogoWidth}
                    kioskUiLogoHeight={kioskUiLogoHeight}
                  />
                </div>
                <div style={{color:kioskUiTitleTextColor ? kioskUiTitleTextColor : colors.secondary,fontSize:"40px",display : "flex" ,maxHeight:"12vh", alignItems: "center",justifyContent: "center", height:kioskUiLogoHeight, paddingTop:tearApartVehicleOgden || tearApartVehicleSlc || kioskUiVehicleConfig ?"2%":"3%"}}>
                  {
                    tearApartVehicleOgden || tearApartVehicleSlc || kioskUiVehicleConfig?
                    (<b>Just In Vehicle Alerts!</b>):
                    (<b>VIP Club!</b>)
                  }
                  
                </div>
              </div>
            )
            :(
              <Logo
                border={kioskUiLogoBorderEnable}
                borderColor={kioskUiLogoBorderColor ? kioskUiLogoBorderColor : colors.secondary}
                logo={centralFloridaPickAndPay?centralFloridaPickAndPayLogo:logo}
                maxHeight="12vh"
                kioskUiLogoWidth={kioskUiLogoWidth}
                kioskUiLogoHeight={kioskUiLogoHeight}
              />
            )}

            <Title size={"2.25rem"} color={kioskUiTitleTextColor ? kioskUiTitleTextColor : colors.secondary}>
              {tearApart || tearApartCheckinOgden || tearApartCheckinSlc? "Enter Your Phone Number to Check-In:" : ""}
              {tearApartJoinOgden || tearApartJoinSlc ? "Enter Your Phone Number to Join:" : ""}
              {(!tearApartAll && !kioskUiTabletView && !kioskUiVehicleConfig && !kioskUiAllInOneCheckIn) ? "Enter Your Phone Number:" : ""}
              { tearApartVehicleOgden || tearApartVehicleSlc || kioskUiVehicleConfig ? "Enter Your Mobile Phone Number To Add Vehicles:" : ""}
              { kioskUiTabletView || kioskUiAllInOneCheckIn? "Enter Your Phone Number to Check-In:" : ""}
            </Title>
            <Title size={"1.5rem"} color={kioskUiTitleTextColor ? kioskUiTitleTextColor : colors.secondary}>
              {tearApart  || tearApartCheckinOgden || tearApartCheckinSlc ? "Introduce tu Numero de Telefono para hacer el Check-In:" : ""}
              {tearApartJoinOgden || tearApartJoinSlc ? "Introduce tu Numero de Telfono para hacer el Join:" : ""}
              {(!tearApartAll && !kioskUiTabletView && !kioskUiVehicleConfig && !kioskUiAllInOneCheckIn) ? "Numero Telefonico:" : ""}
              { tearApartVehicleOgden || tearApartVehicleSlc || kioskUiVehicleConfig ? "Introduzca su número de teléfono móvil para añadir vehículos:" : ""}
              { kioskUiTabletView || kioskUiAllInOneCheckIn? "Introduce tu Numero de Telefono para hacer el Check-In:" : ""}
            </Title>
            <SitePath style={{ color: kioskUiTextColor, display: kioskUiHideCity && "none" }}>{ogden?'ogden':sitePath}</SitePath>
          </Column>
          <Column align="center" justify="space-around" style={{ marginTop:"30px" }}>
            <Row>
              <MobileNumber
                type="tel"
                onChange={this.handleInput}
                placeholder="(xxx)xxx-xxxx"
                value={mobile === "" ? "" : prettyMobile(mobile)}
              />
              <BackButton
                bg={kioskUiButtonPrimaryColor ? kioskUiButtonPrimaryColor : colors.primary}
                borderRadius="right"
                disabled={sending}
                margin="0"
                onClick={this.handleKeypadButton}
                size="2rem"
                value="backspace"
              >
                <BackArrow />
              </BackButton>
            </Row>
            {allowOptOut && !tearApart && !tearApartCheckinOgden && !tearApartCheckinSlc && !kioskUiTabletView && (
              <div style={{ display: "flex", justifyContent: "space-between", minWidth: "300px" }}>
                <LoaderButton
                  bg={kioskUiButtonErrorColor ? kioskUiButtonErrorColor : colors.error}
                  size={"1.5em"}
                  loading={sending}
                  name="opt-out"
                  onClick={this.handleEnter}
                  data-lan="eng"
                  style={{ padding: "10px 20px", marginRight: "5px" }}
                >
                  {tearApart ? 'Opt Out / Skip To Waiver' : 'Opt Out'}
                </LoaderButton>
                <LoaderButton
                  bg={kioskUiButtonErrorColor ? kioskUiButtonErrorColor : colors.error}
                  size={"1.5em"}
                  loading={sending}
                  name="opt-out"
                  onClick={this.handleEnter}
                  data-lan="esp"
                  style={{ padding: "10px 20px", marginLeft: "5px" }}
                >
                  {tearApart ? 'Optar Por No - Saltar a la Renuncia' : 'Optar Por No'}
                </LoaderButton>
              </div>
            )}
            {allowOptOut && (tearApart || tearApartCheckinOgden || tearApartCheckinSlc || kioskUiTabletView) && (
                <div style={{display:'block',position: "absolute",top:"40%", left:"63%"}}>
                  <LoaderButton
                    bg={kioskUiButtonErrorColor ? kioskUiButtonErrorColor : colors.error}
                    size={"1.5em"}
                    loading={sending}
                    name="opt-out"
                    onClick={this.handleEnter}
                    data-lan="eng"
                    style={{ padding: "10px 20px"}}
                  >
                    {(tearApart || tearApartCheckinOgden || tearApartCheckinSlc || kioskUiTabletView) ? 'Opt Out / Skip To Waiver' : 'Opt Out'}
                  </LoaderButton>
                  <LoaderButton
                    bg={kioskUiButtonErrorColor ? kioskUiButtonErrorColor : colors.error}
                    size={"17px"}
                    loading={sending}
                    name="opt-out"
                    onClick={this.handleEnter}
                    data-lan="esp"
                    style={{ padding: "13px 19px"}}
                  >
                    {(tearApart || tearApartCheckinOgden || tearApartCheckinSlc || kioskUiTabletView) ? 'Optar Por No - Saltar a la Renuncia' : 'Optar Por No'}
                  </LoaderButton>
                </div>
              )}
            
            <Keypad
              colors={colors}
              disabled={sending}
              isUppercase={false}
              onHandleKeypadClick={this.handleKeypadButton}
              type="numbers"
              site={site}
            />

          </Column>
          <Row align="baseline" justify="space-around">
            {/* Don't need to reset on the first screen */}
            {/* <ResetButton /> */}
            <Column align="center" justify="center">
              {!kioskUiHideAdvIn && kioskUiHideAdvIn !== undefined && (
                <div style={{ width: kioskUiAdvWidth, marginTop: kioskUiAdvTop, marginBottom: kioskUiAdvBottom }}>
                  <Slider
                    {...sliderSetting}
                    style={{ width: kioskUiAdvWidth }}
                    asNavFor={this.state.nav2}
                    ref={(slider) => (this.slider1 = slider)}
                  >
                    {kioskUiInAdvFile1 && (
                      <div>
                        <img
                          src={kioskUiInAdvFile1}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiInAdvFile2 && (
                      <div>
                        <img
                          src={kioskUiInAdvFile2}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiInAdvFile3 && (
                      <div>
                        <img
                          src={kioskUiInAdvFile3}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiInAdvFile4 && (
                      <div>
                        <img
                          src={kioskUiInAdvFile4}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiInAdvFile5 && (
                      <div>
                        <img
                          src={kioskUiInAdvFile5}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiInAdvFile6 && (
                      <div>
                        <img
                          src={kioskUiInAdvFile6}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiInAdvFile7 && (
                      <div>
                        <img
                          src={kioskUiInAdvFile7}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiInAdvFile8 && (
                      <div>
                        <img
                          src={kioskUiInAdvFile8}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiInAdvFile9 && (
                      <div>
                        <img
                          src={kioskUiInAdvFile9}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiInAdvFile10 && (
                      <div>
                        <img
                          src={kioskUiInAdvFile10}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                  </Slider>
                </div>
              )}
              {(!kioskUiHideContBtn || mobileIsValid)?
              <LoaderButton
                bg={ tearApart || tearApartAll? "#FFA500" : (kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success)}
                disabled={!mobileIsValid || continueBtnDisable}
                disableColor={kioskUiButtonDisabledColor}
                loading={sending}
                name="opt-in-english"
                size={"2rem"}
                onClick={this.handleEnter}
                style={{ marginRight:tearApart || tearApartAll || kioskUiTabletView?"18%":'none' ,display : tearApart || tearApartAll || kioskUiTabletView ? mobileIsValid ? "block" : "none" : "block", color: tearApart || tearApartAll? "#45444A" : kioskUiContinueBtnTextColor }}
              >
                Continue in English
              </LoaderButton>
              :''}
              {!optInField && (
                <DisclaimerText
                  color={kioskUiTermTextColor ? kioskUiTermTextColor : colors.warning}
                  style={{ marginTop:!mobileIsValid && (tearApartAll || kioskUiTabletView) ? "70px" : "0px", fontSize: kioskUiTermTextSize, marginBottom:tearApart || tearApartAll || kioskUiTabletView ?"8px":'none', marginRight:tearApart || tearApartAll || kioskUiTabletView ? "20%":'none' }}
                >
                  By pressing Continue, you are signing up to receive automated text alerts and marketing calls from an
                  autodialer system or live person. Consent to receive automated text alerts and marketing calls not
                  required for purchase. Approx 9 msgs/mo. Msg &amp; Data Rates May Apply. Reply HELP for HELP, STOP ALL
                  to cancel. Ts & Cs / Privacy Policy https://client.texnrewards.net/terms_of_use.asp
                </DisclaimerText>
              )}
            </Column>
            <Column align="center" justify="center">
              {!kioskUiHideAdvOut && kioskUiHideAdvOut !== undefined && (
                <div style={{ width: kioskUiAdvWidth, marginTop: kioskUiAdvTop, marginBottom: kioskUiAdvBottom }}>
                  <Slider
                    {...sliderSetting}
                    style={{ width: kioskUiAdvWidth }}
                    asNavFor={this.state.nav1}
                    ref={(slider) => (this.slider2 = slider)}
                  >
                    {kioskUiOutAdvFile1 && (
                      <div>
                        <img
                          src={kioskUiOutAdvFile1}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiOutAdvFile2 && (
                      <div>
                        <img
                          src={kioskUiOutAdvFile2}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiOutAdvFile3 && (
                      <div>
                        <img
                          src={kioskUiOutAdvFile3}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiOutAdvFile4 && (
                      <div>
                        <img
                          src={kioskUiOutAdvFile4}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiOutAdvFile5 && (
                      <div>
                        <img
                          src={kioskUiOutAdvFile5}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiOutAdvFile6 && (
                      <div>
                        <img
                          src={kioskUiOutAdvFile6}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiOutAdvFile7 && (
                      <div>
                        <img
                          src={kioskUiOutAdvFile7}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiOutAdvFile8 && (
                      <div>
                        <img
                          src={kioskUiOutAdvFile8}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiOutAdvFile9 && (
                      <div>
                        <img
                          src={kioskUiOutAdvFile9}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiOutAdvFile10 && (
                      <div>
                        <img
                          src={kioskUiOutAdvFile10}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                  </Slider>
                </div>
              )}
              {(!kioskUiHideContBtn || mobileIsValid)?
              <LoaderButton
                bg={tearApart || tearApartAll ? "#FFA500" : ( kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success )}
                disabled={!mobileIsValid || continueBtnDisable}
                disableColor={kioskUiButtonDisabledColor}
                loading={sending}
                size={"2rem"}
                name="opt-in-spanish"
                onClick={this.handleEnter}
                style={{ marginLeft:tearApart || tearApartAll || kioskUiTabletView ?"10%":'none' ,display : tearApart || tearApartAll || kioskUiTabletView ? mobileIsValid ? "block" : "none" : "block", color: tearApart || tearApartAll? "#45444A" : kioskUiContinueBtnTextColor }}
              >
                Continuar en Espanol
              </LoaderButton>
              :''}
              {!optInField && (
                <DisclaimerText
                  color={kioskUiTermTextColor ? kioskUiTermTextColor : colors.warning}
                  style={{ marginTop:!mobileIsValid && (tearApartAll || kioskUiTabletView) ?"70px":"0px", fontSize: kioskUiTermTextSize, marginBottom:tearApart || tearApartAll || kioskUiTabletView ?"8px":"none", marginLeft:tearApart || tearApartAll || kioskUiTabletView ?"20%":"none" }}
                >
                  Presionando siguiente, te estás inscribiendo para recibir alertas automáticas de texto de un Sistema
                  de marcado automático. El consentimiento para recibir alertas automáticas de texto no es necesario
                  para compra. Aproximadamente 9 mensajes / mes. Se pueden aplicar tarifas de mensajes y datos. Responde
                  a la ayuda por ayuda, deja de cancelar. Ts y Cs / Politica de privacidad
                  https://client.texnrewards.net/terms_of_use.asp
                </DisclaimerText>
              )}
            </Column>
          </Row>
          <AdminControls onToggleAdminControls={this.toggleAdminControls} show={showAdminControls} />
        </MobileContainer>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = ({ router: { allowOptOut, guid, optInField, siteId, sitePath }, theme, user }: IState) => ({
  allowOptOut,
  guid,
  optInField,
  siteId,
  sitePath,
  theme,
  user,
});

const mapDispatchToProps = {
  onGetCheckIns: getCheckIns,
  onGetLoyaltyCycleText: getLoyaltyCycleText,
  onGetUserRewardText: getUserRewardText,
  onNavigateToNext: navigateToNext,
  onRefreshCoupons: refreshCoupons,
  onSetLanguage: setLanguage,
  onSetUserValue: setUserValue,
  onWatchCoupons: watchCoupons,
};

export default connect<IMobileStateProps, IMobileDispatchProps, IMobileOwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(Mobile);



// WEBPACK FOOTER //
// ./src/views/Mobile.tsx